// removed by extract-text-webpack-plugin
module.exports = {"notFoundWrapper":"_2Jg-5NaWpqmxQAJuowGn53","content":"_1UR-3k45Ad2dnDaRU_Kn-_","formSearch":"_3rkFjQ948FjX8FIZcV1_GM","icon":"_1lfigJCGezLjJDM8Z0AEE4"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/InvitationExpiredPage/InvitationExpiredPage.scss
// module id = 1859
// module chunks = 0